import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSWheatTortillaProduct from 'models/BSWheatTortillaProduct'
import WheatTortillaPackage from './WheatTortillaPackage'
import BrandSpecificProductDesc from 'views/shared/BrandSpecificProductDesc'
import { brandNameOptions } from './constants'

const productOptions = {
  // eslint-disable-next-line react/display-name
  productDesc: () => (
    <BrandSpecificProductDesc initialBrandNameOptions={brandNameOptions} />
  ),
  packagingInfo: <WheatTortillaPackage />,
  productTitle: 'Brand Specific Whole Wheat Tortillas',
  model: BSWheatTortillaProduct,
  validCategories: ['16'],
  validSubCategories: ['008BS'],
  brandSpecific: true,
}

const BSWheatTortilla = () => <ProductForm product={productOptions} />

export default BSWheatTortilla

export const getBSWheatTortillaPackage = newProduct => {
  const newBSWheatTortillaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSWheatTortillaPackage
}

export const updateBSWheatTortillaPackage = newProduct => {
  const newBSWheatTortillaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSWheatTortillaPackage
}
